export default __webpack_public_path__ + "static/media/Speed.a680a5af.svg";